@if (isVisible$ | async) {
  <hls-button
    (click)="redirectToUpgradeCenter()"
    (keydown.enter)="redirectToUpgradeCenter()"
    [attr.button-style]="buttonStyle"
    >
    <span [translate]="'navigation.upgrade-center.cta'"></span>
  </hls-button>
}
